<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("eWallet") }}</div>
    </div>
    <div class="white-wrapper mt-4">
      <!-- SECTION 1 -->
      <div class="refund-center-content m-5" v-if="section.one">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="input-material mb-4">
            <input
              v-model="customer_number"
              type="number"
              autofocus
              required="required"
              v-on:keyup.enter="show2"
              placeholder="Registered Phone Number"
            />
            <label :class="customer_number ? 'shift-up' : ''">{{
              "Registered Phone Number"
            }}</label>
          </div>

          <button v-on:click="show2()" class="btn-blue-lg">
            {{ $t("submit") }}
          </button>
        </div>
      </div>

      <!-- SECTION 2  -->
      <div class="" v-if="section.two">
        <div class="row">
          <div class="col-8">
            <h6 class="mb-3">
              {{ $t("name") }} : {{ walletDetails.cust_name || "-" }}
            </h6>
            <h6 class="mb-3">
              {{ $t("mobileno") }} : {{ walletDetails.cust_mobile || "-" }}
            </h6>
            <h6 class="mb-3">
              {{ $t("emailaddress") }} :
              {{ walletDetails.cust_email || "-" }}
            </h6>
          </div>
          <div class="col-4">
            <div class="d-flex justify-content-end align-items-center mr-3">
              <div class="icon-e-wallet"></div>
              <div class="e-wallet-balance fs-20 font-weight-bold">
                {{
                  parseFloat(walletDetails.wallet_balance || 0).toFixed(
                    this.MIN_FRACTION_DIGITS
                  ) || 0
                }}
                {{ currencyData.curr_code }}
              </div>
            </div>
          </div>
        </div>
        <div class="text-center" v-if="!EmpireClient">
          <button
            v-if="$can('update', 'E-Wallet')"
            @click="$bvModal.show('credit-debit')"
            class="btn-blue"
          >
            {{ $t("add_money") }}/{{ $t("debit_cash") }}
          </button>
        </div>
        <div class="row mt-5">
          <div class="col-5">
            <div class="section-title">
              {{ "Wallet History" }}
            </div>
          </div>
          <div class="col-7">
            <div class="row justify-content-end">
              <div class="col-lg-6 col-xl-4 align-self-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="from_date"
                      v-on:click="from_date = ''"
                    >
                      ✖
                    </button>
                    <Datepicker
                      v-model="from_date"
                      ref="from_date"
                      typeable
                    ></Datepicker>
                    <label :class="from_date ? 'active' : ''">{{
                      $t("fromdate")
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-xl-4 align-self-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="to_date"
                      v-on:click="to_date = ''"
                    >
                      ✖
                    </button>
                    <Datepicker
                      v-model="to_date"
                      ref="to_date"
                      typeable
                    ></Datepicker>
                    <label :class="to_date ? 'active' : ''">{{
                      $t("todate")
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-xl-2 align-self-center">
                <button
                  @click.prevent.stop="refreshWalletDetails()"
                  class="btn btn-blue w-100 px-2"
                >
                  {{ $t("apply_filter") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 table-scroll">
          <table class="list-view-table wallet_logs mb-2" border="1">
            <thead class="text-center">
              <tr>
                <th>{{ $t("createdat") }}</th>
                <th>{{ "Amount" }}</th>
                <th>{{ $t("bookingCode") }}</th>
                <th>{{ $t("fnbOrder") }}</th>
                <th>{{ $t("closing_balance") }}</th>
                <th>{{ $t("remarks") }}</th>
              </tr>
            </thead>
            <tbody v-if="wallet_history.length == 0">
              <tr>
                <td colspan="7">
                  <h3 class="text-center">{{ "No records found" }}</h3>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr
                v-for="(log, logIndex) in wallet_history"
                :key="logIndex"
                class="light_grey_back"
              >
                <td class="">
                  {{ log.created_at | dateParseYYYYMMDD }}
                </td>
                <td
                  class="text-right"
                  v-if="log.transaction_type == 'credit'"
                  style="color: green"
                >
                  {{ currencyData.curr_code }} {{ currFormat(log.t_amount) }}
                </td>
                <td class="text-right" v-else style="color: red">
                  -{{ currencyData.curr_code }} {{ currFormat(log.t_amount) }}
                </td>

                <td class="">
                  {{ log.sb_booking_code ? log.sb_booking_code : "-" }}
                </td>
                <td class="">
                  {{ log.receipt_code ? log.receipt_code : "-" }}
                </td>
                <td class="text-right">
                  {{ currencyData.curr_code }}
                  {{ currFormat(log.current_balance) }}
                </td>
                <td class="">{{ log.remark }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          @change="onChangePagination($event)"
          :per-page="perPage"
          aria-controls="my-table"
          class="my-3"
          v-if="wallet_history.length > 0"
        ></b-pagination>
      </div>
    </div>
    <b-modal id="credit-debit" title="Credit/Debit" hide-header hide-footer>
      <div class="col-12 text-center mb-4 pb-2 mt-3">
        <h4>{{ $t("add_money") }}/{{ $t("debit_cash") }}</h4>
      </div>

      <div class="col-lg-12 col-xl-12 mb-1">
        <div class="d-flex align-items-center">
          <multiselect
            :options="['Add Cash', 'Deduct Cash']"
            v-model="adminCredit.selected_action"
            :searchable="true"
            placeholder="Select Action"
            :allowEmpty="false"
            :showLabels="false"
          ></multiselect>
        </div>
      </div>
      <div class="col-lg-12 col-xl-12 mt-4 mb-1">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <input
              type="text"
              id="Amount"
              name="Amount"
              v-model="adminCredit.amount"
              placeholder="."
              v-on:keydown="
                (e) => {
                  if (
                    !/[0-9]/.test(e.key) &&
                    e.keyCode !== 8 &&
                    e.keyCode !== 190
                  ) {
                    e.preventDefault();
                  }
                }
              "
            />
            <label>Amount</label>
          </div>
        </div>
      </div>

      <div class="col-lg-12 col-xl-12 mt-4 mb-2">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <input
              type="text"
              id="reason"
              name="reason"
              v-model="adminCredit.remark"
              placeholder="."
            />
            <label>Reason</label>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xl-12 mb-1 text-center">
        <button @click.prevent.stop="updateBalance" class="btn-blue">
          {{ $t("update") }}
        </button>
        <button
          @click.prevent.stop="$bvModal.hide('credit-debit')"
          class="btn-blue"
        >
          Cancel
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PosService from "@/services/PosService.js";
import MasterService from "@/services/MasterService.js";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import { Role, CLIENT_NAME } from "@/helper/Role";
import _ from "lodash";
import moment from "moment";

export default {
  components: {
    ManagerAuthLogin,
  },
  data() {
    return {
      customer_number: "",
      customer_id: null,
      currencyData: {
        curr_code: "",
      },
      adminCredit: {
        amount: 0,
        remark: "",
        selected_action: "Add Cash",
      },
      walletDetails: {
        wallet_balance: 0,
        cust_id: null,
        cust_email: "",
        cust_name: "",
        cust_mobile: "",
      },
      wallet_history: [],
      from_date: null,
      to_date: null,
      currentPage: 1,
      rows: 0,
      perPage: 10,
      selectedvalue: 10,
      section: {
        one: true,
        two: false,
        three: false,
      },
    };
  },
  watch: {},
  computed: {
    EmpireClient() {
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
    },
  },
  mounted() {
    this.getCurrencyCode();
    const { cust_id } = this.$route.query;
    if (cust_id) {
      this.show2(cust_id);
    }
  },
  methods: {
    updateBalance() {
      if (isNaN(this.adminCredit.amount)) {
        this.$toasted.show("Please enter a valid amount.");
        return;
      } else if (this.adminCredit.amount == 0) {
        this.$toasted.show("Please Enter Amount.");
        return;
      } else {
        let payload = {};
        if (this.adminCredit.selected_action == "Add Cash") {
          payload = {
            customer_id: this.walletDetails["cust_id"] || null,
            amount: +parseFloat(this.adminCredit.amount || 0).toFixed(
              this.MIN_FRACTION_DIGITS
            ),
            remark: this.adminCredit.remark || "",
            type: 3,
          };
        } else if (this.adminCredit.selected_action == "Deduct Cash") {
          payload = {
            customer_id: this.walletDetails["cust_id"] || null,
            amount: +parseFloat(this.adminCredit.amount || 0).toFixed(
              this.MIN_FRACTION_DIGITS
            ),
            remark: this.adminCredit.remark || "",
            type: 4,
          };
        } else {
          this.$toasted.show("Please Select Action Type");
          return false;
        }

        PosService.TopUpWallet(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$bvModal.hide("credit-debit");
              this.currentPage = 1;
              this.refreshWalletDetails();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      }
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error :", error);
        });
    },
    showSection(section) {
      Object.keys(this.section).map((key) => {
        if (key.toLowerCase() == section.toLowerCase()) {
          this.section[key] = true;
        } else {
          this.section[key] = false;
        }
      });
    },
    show1: function () {
      this.showSection("one");
    },
    show2: function (cust_id) {
      if (!this.customer_number && !cust_id) {
        this.$toasted.show("Please Enter Registered Number.");
        return false;
      } else {
        let loader = this.$loading.show();
        let payload = {
          cust_mobile: this.customer_number,
        };
        if (cust_id) {
          payload["customer_id"] = cust_id;
        }
        PosService.getWalletBalance(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.hasOwnProperty("customer_details")) {
                Object.keys(this.walletDetails).map((key) => {
                  this.walletDetails[key] = data.customer_details[key];
                });
                this.showSection("two");
                this.getCustomerWalletHistory();
              }
            } else {
              this.$toasted.show(data.message || "Something Went Wrong!");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            this.$toasted.show("Something Went Wrong!");
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    show3: function (confirmStock = false) {},
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getCustomerWalletHistory();
      } else {
        this.currentPage = event;
        this.getCustomerWalletHistory();
      }
    },
    onChangeDates() {},
    getCustomerWalletHistory() {
      if (this.walletDetails["cust_id"]) {
        let payload = {
          cust_id: this.walletDetails["cust_id"],
          from_date:
            this.from_date && moment(this.from_date).isValid()
              ? moment(this.from_date).format("YYYY-MM-DD")
              : null,
          to_date:
            this.to_date && moment(this.to_date).isValid()
              ? moment(this.to_date).format("YYYY-MM-DD")
              : null,
          perPage: this.perPage,
          currentPage: this.currentPage,
        };
        this.wallet_history = [];
        PosService.getWalletHistoryLogs(payload)
          .then((response) => {
            const { data } = response;
            if (
              data.status &&
              data.Records &&
              data.Records.hasOwnProperty("data") &&
              data.Records.data.length > 0
            ) {
              this.wallet_history = data.Records.data;
              if (data.Records.pagination.hasOwnProperty("total")) {
                if (data.Records.pagination.total >= 10) {
                  this.rows = data.Records.pagination.total;
                } else {
                  this.rows = data.Records.pagination.total;
                  this.selectedvalue = data.Records.pagination.total;
                }
              }
            } else {
              this.$toasted.show(data.message || "Something Went Wrong!");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      } else {
        this.$toasted.show("Customer Not Found, Please Refresh & Try Again");
      }
    },
    refreshWalletDetails() {
      if (
        this.from_date &&
        this.to_date &&
        moment(this.from_date).isAfter(moment(this.to_date))
      ) {
        this.$toasted.show("From date cannot be greater than To date.");
        return;
      }
      if (this.walletDetails["cust_id"]) {
        let loader = this.$loading.show();
        let payload = {
          customer_id: this.walletDetails["cust_id"],
        };
        PosService.getWalletBalance(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.hasOwnProperty("customer_details")) {
                Object.keys(this.walletDetails).map((key) => {
                  this.walletDetails[key] = data.customer_details[key];
                });
                this.getCustomerWalletHistory();
              }
            } else {
              this.$toasted.show(data.message || "Something Went Wrong!");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            this.$toasted.show("Something Went Wrong!");
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
  },
};
</script>
<style>
.invalid_input {
  border: 1px solid red !important;
  border-radius: 10px;
}
.customer_drop_down {
  background-color: none !important;
}

.disableRefundBtn {
  opacity: 0.5;
  pointer-events: none;
}

.wallet_logs tr td {
  padding-right: 10px !important;
  padding-left: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/eWalletComponent/eWallet.vue